import React from 'react'
import {Popup} from 'semantic-ui-react'
import {TicketChip} from '../purchase-orders/ticket-chip'
import {needsTickets, ticketLabel} from '../purchase-orders/needs-tickets'

// vpos.tickets is a per-cad array using the same vocabulary as sales orders
// (NO / YES FACTORY / YES-LA / YES-CHINA/LA). There is no tickets_ordered on
// the vpo side, so the chip is always the not-ordered colour.
const vpoTicketPopup = (tickets) => {
  if (!needsTickets(tickets)) { return null }

  return (
    <Popup
      size='mini'
      header='This vendor order needs tickets'
      content={<div>Type: <b>{ticketLabel(tickets)}</b></div>}
      position='bottom left'
      trigger={<TicketChip ticketed={tickets}/>}
    />
  )
}

export {vpoTicketPopup}
